import cx from 'clsx'
import React, { DetailedHTMLProps, HTMLAttributes } from 'react'

import cn from '../styles.module.scss'

export interface IListProps
  extends DetailedHTMLProps<
    HTMLAttributes<HTMLUListElement>,
    HTMLUListElement
  > {
  bgColor?: 'grey' | 'white'
  align?: 'center' | 'start' | 'end' | 'between'
  direction?: 'row' | 'col'
}

const List = ({
  direction,
  align,
  bgColor,
  children,
  className,
  ...rest
}: IListProps) => {
  const classes = cx(
    align && cn[align],
    bgColor && cn[bgColor],
    direction && cn[direction],
    className,
  )
  return (
    <ul {...rest} className={classes}>
      {children}
    </ul>
  )
}

export default List
